document.addEventListener('DOMContentLoaded', function() {
  // Function to fix country selector close button behavior
  function fixCountrySelectorBehavior() {
    // Original hidePanel function from localization-form.js
    const originalHidePanel = customElements.get('localization-form').prototype.hidePanel;
    
    // We need to override the entire prototype to completely replace the hidePanel function
    if (originalHidePanel) {
      customElements.get('localization-form').prototype.hidePanel = function(event) {
        // If this is triggered from a close button click, prevent the drawer from closing
        if (event && event.type === 'click' && event.target.closest('.country-selector__close-button')) {
          // Basic functionality from original hidePanel but without closing the drawer
          this.elements.button.setAttribute('aria-expanded', 'false');
          this.elements.panel.setAttribute('hidden', true);
          
          if (this.elements.search) {
            this.elements.search.value = '';
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
          
          // Important: don't remove body overflow class or country-selector-open from drawer
          document.querySelector('.menu-drawer').classList.remove('country-selector-open');
          
          // Prevent further propagation to avoid any default closing behavior
          event.stopPropagation();
          event.preventDefault();
          return false;
        }
        
        // For other cases, call the original function
        return originalHidePanel.apply(this, arguments);
      };
    }
    
    // Add direct click handler on all close buttons as a fallback
    const closeButtons = document.querySelectorAll('.country-selector__close-button');
    closeButtons.forEach(button => {
      // Remove any existing listeners
      button.removeEventListener('click', handleCloseButtonClick);
      // Add our custom listener
      button.addEventListener('click', handleCloseButtonClick, true);
    });
  }
  
  // Handle close button click - capture phase to run before other handlers
  function handleCloseButtonClick(event) {
    const menuDrawer = document.querySelector('.menu-drawer');
    
    if (menuDrawer) {
      // Prevent the event from reaching other handlers
      event.stopPropagation();
      event.preventDefault();
      
      // Get the disclosure panel
      const panel = event.target.closest('.disclosure__list-wrapper');
      if (panel) {
        panel.setAttribute('hidden', true);
      }
      
      // Get the toggle button and update its state
      const button = menuDrawer.querySelector('button.localization-form__select');
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
      
      // Remove country selector open class from menu drawer
      menuDrawer.classList.remove('country-selector-open');
      
      return false;
    }
  }
  
  // Run on page load with a delay to ensure the custom element is defined
  setTimeout(fixCountrySelectorBehavior, 300);
  
  // Run when DOM changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        // Check if any added nodes contain close buttons
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && (node.classList?.contains('country-selector__close-button') || 
              node.querySelector?.('.country-selector__close-button'))) {
            fixCountrySelectorBehavior();
          }
        });
      }
    });
  });
  
  // Start observing the document body
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Also run when sections load
  document.addEventListener('shopify:section:load', fixCountrySelectorBehavior);
}); 